import ContainerConfig from './container/ContainerConfig'
import AdSlot from './AdSlot'
import Logger from './Log'
import { inFrame, instanceIdx } from './utils'

const Log = Logger.for('AdSlotUtility')

/**
 * Return a list of AdSlot nodes which are target containers for an ad unit
 * @param config ContainerConfig
 * @returns {[]|Array|AdSlot[]}
 */
export function getAdSlots (config, zoneId, currentScript) {
  if (!(config instanceof ContainerConfig)) throw Error('Config not a ContainerConfig')

  let wind = false

  const sel = config.selector()

  const idx = instanceIdx(zoneId)
  if (idx > 0) {
    Log.info('Detected multiple instances of tag ' + zoneId + ', current index ' + idx)
  }

  const frame = inFrame()
  if (frame.inFrame) {
    if (!frame.crossDomain) {
      Log.debug('In friendly frame, breaking out and 1x1ing ' + frame.frameId)
      window.frameElement.style.width = '1px !important'
      window.frameElement.style.height = '1px !important'
      window.frameElement.width = '1'
      window.frameElement.height = '1'
      window.frameElement.style.display = 'block'

      if (!sel) {
        Log.debug('No selector but in iframe, using current frame')
        return [new AdSlot(window.frameElement, zoneId, idx)]
      }
    } else {
      Log.warn('In xdomain iframe, must use current frame body')

      if (sel) {
        Log.error('Selector provided but stuck in xdomain frame, fatal error')
        return []
      }

      wind = window // of current frame fml, cant access top
    }
  }

  if (!wind) {
    Log.debug('Using window.top')
    wind = window.top
  }

  if (!sel || !sel.length) {
    Log.debug('No target selector provided')

    if (currentScript) {
      Log.debug('Placing next to currentScript')
      return [new AdSlot(currentScript, zoneId, idx)]
    }

    Log.debug('Falling back to body selector')
    return [new AdSlot(wind.document.body, zoneId, idx)]
  }

  if (sel.toUpperCase() === 'WINDOW') {
    Log.debug('Container location in place or attached to window')
    return [new AdSlot(wind.document.body, zoneId, idx)]
  }

  const nodes = wind.document.querySelectorAll(sel)
  if (!nodes || !nodes.length) {
    Log.warn('Quitting, no nodes found with selector ' + sel)
    return []
  }

  const slots = []
  let x = 0
  for (const node of nodes) {
    Log.debug('Found target ad slot parent #' + ++x)
    slots.push(new AdSlot(node, zoneId + '-' + x, idx))
  }

  return slots
}
